import { render, staticRenderFns } from "./SalutProfile.vue?vue&type=template&id=ee4a5628&"
import script from "./SalutProfile.vue?vue&type=script&lang=js&"
export * from "./SalutProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports